"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileHeaderEditModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = require("styled-components");
const CompanyProfileHeaderEditForm_1 = __importDefault(require("./CompanyProfileHeaderEditForm"));
const CompanyProfileHeaderEditModal = ({ isEditModalOpen, setIsEditModalOpen, company }) => {
    const companyProfileHeaderFormRef = react_1.default.useRef(null);
    const intl = (0, react_intl_1.useIntl)();
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { title: intl.formatMessage({
            id: 'admin.company_premium_profile.edit_company_profile_header',
        }), visible: isEditModalOpen, width: theme.modalWidth.largeModal, onOk: () => { var _a; return (_a = companyProfileHeaderFormRef.current) === null || _a === void 0 ? void 0 : _a.submitForm(); }, onCancel: () => setIsEditModalOpen(false), children: (0, jsx_runtime_1.jsx)(CompanyProfileHeaderEditForm_1.default, { setIsEditModalOpen: setIsEditModalOpen, company: company, ref: companyProfileHeaderFormRef }) }));
};
exports.CompanyProfileHeaderEditModal = CompanyProfileHeaderEditModal;
